import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var AbsorberSizeLimit = /*#__PURE__*/function () {
  function AbsorberSizeLimit() {
    _classCallCheck(this, AbsorberSizeLimit);
    this.radius = 0;
    this.mass = 0;
  }
  _createClass(AbsorberSizeLimit, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.mass !== undefined) {
        this.mass = data.mass;
      }
      if (data.radius !== undefined) {
        this.radius = data.radius;
      }
    }
  }]);
  return AbsorberSizeLimit;
}();